<template>
  <div class='masonry-container' ref="masonryContainer" v-infinite-scroll='loadMore'
       :infinite-scroll-disabled='loading || noMoreData' :infinite-scroll-distance="100"
       :infinite-scroll-immediate='false'>
    <template v-if="dataList.length !== 0">
      <el-card class='card' v-for='(item) in dataList' :key='item.id' shadow='hover'>
        <el-skeleton animated :loading='loading'>
          <template slot='template'>
            <el-skeleton-item variant='image' style='width: 240px; height: 240px;'/>
            <div style='padding: 14px;'>
              <el-skeleton-item variant='p' style='width: 50%'/>
              <div style='display: flex; align-items: center;'>
                <el-skeleton-item variant='text' style='margin-right: 16px;'/>
                <el-skeleton-item variant='text' style='width: 30%;'/>
              </div>
            </div>
          </template>
          <template>
            <div class="product-container">
              <div class='card_content'>
                <div class="content-wrapper">
                  <span>  {{ item.title }}  </span><br/>
                  <span><span class="field-label">颜色/尺码：</span>{{ item.spec_name || '' }} </span><br
                    v-if="item.spec_name && item.spec_name !== ''"/>
                  <span v-if="item.used_season && item.used_season !== ''"><span class="field-label">季节性：</span>{{
                    item.used_season || ''
                  }} </span><br v-if="item.used_season && item.used_season !== ''"/>
                  <span><span class="field-label">日常价：</span><a>{{ item.price || '' }}元</a> </span><br/>
                  <span><span class="field-label">直播价：</span><a>{{ item.lb_price || '' }}元</a> </span><br/>
                  <span><span class="field-label">赠品：</span>{{ item.gift || '' }} </span><br/>
                  <span><span class="field-label">佣金(%)：</span><a>{{
                    item.commission ? item.commission : '' || '暂无'
                  }}</a></span><br v-if="item.commission"/>
                  <span v-if="item.support_situation"><span
                    class="field-label">保价情况：</span><a>{{ item.support_situation || '' }}</a> </span><br
                    v-if="item.support_situation"/>
                  <span><span class="field-label">负责人：</span>{{ item.leader_name || '' }}</span><br/>
                  <span><span class="field-label">是否标品：</span>{{
                    Number(item.wares_standard_is) === 1 ? '标品' : '非标品' || ''
                  }}</span><br/>
                  <span><span class="field-label">可播平台：</span>{{ formatPlatformName(item.platform_name) }}</span>
                </div>
              </div>

              <div class="product-background"
                   :style="{ '--bg-image': 'url(' + (item.cover_url || require('@/assets/icons/no_img_available.png')) + ')' }">
              </div>

              <div class="hotspot-area"></div>

              <img v-if="item.is_sec_kill === 'Y'" src='@/assets/icons/seckill2.png' alt="秒杀标识"
                   class="seckill-badge"/>
              <div class="id-badge">{{ item.id }}</div>
            </div>

            <div class="button-container">

              <el-link icon='el-icon-edit' v-if="userPermissions.indexOf('product_dress_edit')>-1"
                       type='primary' @click='handleEdit(item)'>修改
              </el-link>
              <el-link type='primary' icon='el-icon-shopping-cart-2' @click='handleJoinLive(item)'>添加选品
              </el-link>
              <el-link icon='el-icon-delete' @click='handleDelete(item)'
                       type='primary' v-if="userPermissions.indexOf('product_dress_delete')>-1">删除
              </el-link>
            </div>
          </template>
        </el-skeleton>
      </el-card>

    </template>
    <template v-else>
      <h1 class="text"> o(╥﹏╥)o
        <br/> <br/>暂无数据
      </h1>
    </template>

    <!-- 加载更多提示 -->
    <div class="load-more-container" v-if="dataList.length > 0">
      <div v-if="loadingMore" class="loading-text">
        <i class="el-icon-loading"></i> 加载中...
      </div>
      <div v-else-if="noMoreData" class="no-more-text">
        没有更多数据了
      </div>
    </div>

    <!-- 回到顶部按钮 -->
    <div class="back-to-top" :class="{ 'show': showBackToTop }" @click="scrollToTop">
      <i class="el-icon-caret-top"></i>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Masonry from 'masonry-layout'

export default {
  name: 'DressUpdateCard',
  computed: {
    ...mapGetters(['userPermissions']),
    noMoreData() {
      return this.dataList.length >= this.total && this.total > 0
    }
  },
  props: {
    searchCondition: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      dataList: [],
      total: 0,
      loading:false,
      loadingMore: false,
      showBackToTop: false,
      orderSort: {id: 'desc'},
      pageData: {page_size: 20, current_page: 1},
      isInitLoading: true,
      masonry: null,
      refreshTimer: null,
      scrollThreshold: 300
    }
  },
  methods: {
    handleEdit(row) {
      this.$emit('handleEdit', row.id)
    },
    handleJoinLive(row) {
      this.$emit('handleJoinLive', row)
    },
    handleDelete(row) {
      this.$emit('handleDelete', row)
    },
    // 格式化可播平台数据
    formatPlatformName(platformName) {
      if (!platformName) return ''

      // 如果是数组，则转换为逗号分隔的字符串
      if (Array.isArray(platformName)) {
        return platformName.join('、')
      }

      // 如果是字符串，直接返回
      return platformName
    },
    async getList() {
      // 防止重复请求
      if (this.loading) {
        return
      }
      this.loading = true
      this.pageData.current_page = 1
      const searchCondition = this.searchCondition
      Object.assign(searchCondition, this.pageData, {order: this.orderSort})

      try {
        const {list, pages} = await this.$api.getProductDressList(searchCondition)
        this.dataList = list || []
        this.pageData.current_page = pages.current_page || 1
        this.pageData.page_size = pages.page_size || 20
        this.total = pages.total || 0
        this.loading = false
        this.isInitLoading = false
        this.initMasonry()
      } catch (error) {
        console.error('获取数据失败:', error)
        this.loading = false
      }
    },
    refreshList() {
      // 防止重复刷新
      if (this.loading) {
        return
      }
      this.pageData.current_page = 1
      this.dataList = []
      this.getList()
    },
    initMasonry() {
      this.$nextTick(() => {
        if (this.masonry) {
          this.masonry.destroy()
        }
        const container = this.$refs.masonryContainer
        if (container) {
          this.masonry = new Masonry(container, {
            itemSelector: '.card',
            columnWidth: '.card',
            gutter: 10,
            percentPosition: true,
            transitionDuration: '0.3s'
          })
        }
      })
    },
    updateMasonry() {
      this.$nextTick(() => {
        if (this.masonry) {
          this.masonry.reloadItems()
          this.masonry.layout()
        }
      })
    },
    async loadMore() {
      // Element UI的v-infinite-scroll已经处理了触底检测
      // 我们只需要检查是否应该加载更多数据
      if (this.loadingMore || this.noMoreData || this.isInitLoading) {
        return
      }

      this.loadingMore = true
      this.pageData.current_page += 1

      const searchCondition = this.searchCondition
      Object.assign(searchCondition, this.pageData, {order: this.orderSort})

      try {
        const {list, pages} = await this.$api.getProductDressList(searchCondition)
        if (list && list.length > 0) {
          this.dataList = [...this.dataList, ...list]
          this.total = pages.total || 0
          this.updateMasonry() // 加载更多后更新Masonry布局
        } else {
          this.noMoreData = true
        }
      } catch (error) {
        console.error('加载更多数据失败:', error)
        this.pageData.current_page -= 1 // 回滚页码
      } finally {
        this.loadingMore = false
      }
    },

    // 回到顶部功能
    scrollToTop() {
      const container = this.$refs.masonryContainer
      if (container) {
        container.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },

    // 处理滚动事件
    handleScroll() {
      const container = this.$refs.masonryContainer
      if (container) {
        this.showBackToTop = container.scrollTop > this.scrollThreshold
      }
    },
    addHoverEvents() {
      this.$nextTick(() => {
        document.querySelectorAll('.hotspot-area').forEach(element => {
          const productBackground = element.parentElement.querySelector('.product-background');
          // 使用变量存储定时器ID
          let enterTimeoutId = null;
          let leaveTimeoutId = null;


          let timerId = null;
          let mouseStop = false

          element.addEventListener('mousemove', () => {
            // 每次鼠标移动时，都清除之前的定时器
            clearTimeout(timerId);
            mouseStop = false
            // 重新设置一个新的定时器
            timerId = setTimeout(() => {
              // 如果定时器在指定延迟后被触发，说明鼠标已停止移动
              mouseStop = true
            }, 20);
          });

          // 为了防止鼠标移出元素后动画不触发，我们额外监听 mouseleave 事件
          element.addEventListener('mouseleave', () => {
            // 清除定时器，避免在元素外部意外触发
            clearTimeout(timerId);
          });

          // 鼠标移入事件
          element.addEventListener('mouseenter', () => {
            // 1. 清除离开动画的定时器，防止冲突
            clearTimeout(leaveTimeoutId);

            enterTimeoutId = setInterval(() => {
              if (mouseStop) {
                productBackground.classList.remove('is-leaving');
                productBackground.classList.add('is-hovering');
              }
            }, 25)
          });

          // 鼠标移出事件
          element.addEventListener('mouseleave', () => {
            // 1. 清除进入动画的定时器，防止进入动画触发
            clearTimeout(enterTimeoutId);
            // 2. 延迟0秒添加离开动画类
            leaveTimeoutId = setTimeout(() => {
              productBackground.classList.remove('is-hovering');
              productBackground.classList.add('is-leaving');
            }, 0); // 500毫秒 = 0.5秒
          });
        });
      });
    },
    addDynamicStyles() {
      // 创建style元素
      const styleElement = document.createElement('style');
      styleElement.id = 'dynamic-secondary-nav-styles';

      // 添加CSS样式
      styleElement.textContent = `
       .main-content_bg {
          min-height: auto;
          height: calc(100vh - 140px) !important;
        }
      `;
      // 添加到head
      document.head.appendChild(styleElement);
    },

    // 移除动态添加的CSS样式
    removeDynamicStyles() {
      const styleElement = document.getElementById('dynamic-secondary-nav-styles');
      if (styleElement && styleElement.parentNode) {
        styleElement.parentNode.removeChild(styleElement);
      }
    },
  },
  mounted() {
    this.getList()
    // 添加滚动监听
    const container = this.$refs.masonryContainer
    if (container) {
      container.addEventListener('scroll', this.handleScroll)
    }
    this.addHoverEvents() // 每次数据更新后重新绑定事件
    this.addDynamicStyles(); // 动态添加CSS样式

  },
  updated() {
    this.updateMasonry()
    this.addHoverEvents()

  },
  beforeDestroy() {
    if (this.masonry) {
      this.masonry.destroy()
    }
    // 移除滚动监听
    const container = this.$refs.masonryContainer
    if (container) {
      container.removeEventListener('scroll', this.handleScroll)
    }
    this.removeDynamicStyles()

  },
  watch: {
    searchCondition: {
      handler() {
        // 添加防抖机制，防止频繁触发
        if (this.refreshTimer) {
          clearTimeout(this.refreshTimer)
        }
        this.refreshTimer = setTimeout(() => {
          this.refreshList()
        }, 300) // 300ms防抖延迟
      },
      deep: true,
      immediate: false
    }
  }
}
</script>

<style lang='scss' scoped>
::v-deep .el-card__body {
  padding: 10px !important;
}

// 变量定义
$primary-color: #ff3176;
$success-color: #67C23A;
$warning-color: #E6A23C;
$danger-color: #F56C6C;
$info-color: #909399;
$text-primary: black;
$text-regular: #606266;
$text-secondary: #909399;
$text-placeholder: #C0C4CC;
$border-color: #DCDFE6;
$background-color: #F5F7FA;

// 按钮容器样式 - 固定在底部
.button-container {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  padding-top: 2px;
  margin-bottom: -8px;
  border-top: 1px solid $border-color;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;

  .el-link {
    height: 18px;
    line-height: 18px;
    flex: 1;
    min-width: 0;
    max-width: 25%; // 一排显示4个按钮
    font-size: 14px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 4px 0;

    &:hover {
      transform: translateY(-1px);
    }
  }
}

/* 瀑布流布局 - 一行5个 */
.masonry-container {
  width: 100%;
  box-sizing: border-box;
  height: calc(100% - 36px) !important;
  min-height: 740px;
  overflow-y: scroll;
  transition: all 0.3s ease;

  > .card {
    cursor: pointer;
    width: calc(20% - 15px);
    /* 一行5个，考虑gap */
    margin-bottom: 12px;
    transition: all 0.5s ease;
    border: 1px solid $border-color;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    break-inside: avoid;

    /* 产品容器 - 相对定位容器 */
    .product-container {
      position: relative;
      flex: 1;
      /* 移除 flex 布局，改为普通块级元素 */
      display: block;
      width: 100%;
      min-height: 200px; /* 确保容器有足够高度 */
    }

    .product-background {
      position: absolute;
      top: 0;
      right: 30%;
      width: 40%;
      height: 100%;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0; // 初始定位在左侧
        width: 180px;
        height: 180px;
        background-image: var(--bg-image);
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        transform: translateX(50%) translateY(-50%) scale(1) translateZ(0); // 初始变换
        z-index: 1;
        will-change: transform;
        pointer-events: none;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
      }

      &.is-hovering::before {
        animation: productImageEnter 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
        z-index: 70;
      }

      /* 鼠标移出动画 */
      &.is-leaving::before {
        animation: productImageLeave 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
      }
    }

    /* 卡片内容区域 - 占据100%宽度 */
    .card_content {
      position: relative;
      z-index: 2;
      width: 100%;
      padding: 8px;
      transition: all 0.3s ease;
      box-sizing: border-box; /* 确保padding包含在宽度内 */

      .content-wrapper {
        overflow-x: hidden;
        width: 100%;
        z-index: 1;
        position: relative;

        > span {
          display: inline-block;
          /* 改为inline-block让背景只包裹文字 */
          font-size: 14px;
          line-height: 1.2;
          /* 更紧凑的行高 */
          margin: 2px 0;
          /* 更紧凑的行间距 */
          color: $text-primary;
          word-break: break-word;
          font-weight: 500;
          background: rgba(255, 255, 255, 0.85);
          /* 为文字添加白色背景 */
          padding: 1px 3px;
          /* 减少内边距 */
          border-radius: 2px;
          max-width: 100%;
          /* 限制最大宽度 */

          .field-label {
            color: #71757F;
            padding: 1px 0px;
            border-radius: 2px;
            margin-right: 2px;
          }

          > a {
            color: $danger-color;
            font-weight: 600;
            text-decoration: none;
            transition: color 0.3s ease;

            &:hover {
              color: darken($danger-color, 15%);
              text-decoration: underline;
            }
          }
        }
      }
    }
    .seckill-badge {
      position: absolute;
      top: -20px;
      right: -10px;
      width: 70px;
      height: 70px;
      transform: rotate(15deg);
      /* 倾斜展示 */
      z-index: 44;
      //filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.3));
      /* 添加阴影增强视觉效果 */
    }
    /* ID角标 - 绝对定位在右下角 */
    .id-badge {
      position: absolute;
      bottom: 8px;
      right: -10px;
      background-color: #ff3176;
      color: white;
      font-size: 12px;
      font-weight: bold;
      padding: 4px 10px;
      border-radius: 12px;
      z-index: 45;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      height: 18px;
      line-height: 18px;
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
    }

    /* 透明热区 - 覆盖在图片和文字上方 */
    .hotspot-area {
      position: absolute;
      top: 50%;
      right: 10%;
      width: 200px;
      height: 200px;
      transform: translate(50%, -50%);
      z-index: 50;
      /* 确保在最上层 */
      cursor: pointer;
      /* 调试时可以添加边框查看热区位置 */
      /* border: 1px dashed red; */
    }

    /* 骨架屏样式优化 */
    .el-skeleton {
      .el-skeleton__item {
        border-radius: 4px;
      }
    }
  }

  /* 加载更多容器样式 */
  .load-more-container {
    width: 100%;
    text-align: center;
    padding: 20px 0;
    break-inside: avoid;

    .loading-text {
      color: $primary-color;
      font-size: 14px;

      .el-icon-loading {
        margin-right: 8px;
        animation: rotating 2s linear infinite;
      }
    }

    .no-more-text {
      color: $text-secondary;
      font-size: 14px;
    }
  }

  /* 回到顶部按钮样式 */
  .back-to-top {
    position: fixed;
    bottom: 40px;
    right: 40px;
    width: 50px;
    height: 50px;
    background-color: $primary-color;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    opacity: 0;
    visibility: hidden;
    transform: translateY(20px);
    z-index: 1000;

    &.show {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }

    &:hover {
      background-color: darken($primary-color, 10%);
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }

    i {
      font-size: 20px;
      font-weight: bold;
    }
  }
}

/* 旋转动画 */
@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* 产品图片进入动画 */
@keyframes productImageEnter {
  from {
    transform: translateX(50%) translateY(-50%) scale(1) translateZ(0);
  }

  to {
    transform: translateX(-20%) translateY(-50%) scale(1.3) translateZ(0);
  }
}

/* 产品图片离开动画 */
@keyframes productImageLeave {
  from {
    transform: translateX(-20%) translateY(-50%) scale(1.3) translateZ(0);
  }

  to {

    transform: translateX(50%) translateY(-50%) scale(1) translateZ(0);
  }
}
/* 超大屏幕：5列布局 */
@media (min-width: 1920px) {
  .masonry-container > .card {
    width: calc(20% - 15px);
    /* 一行5个 */
  }
}

/* 大屏幕：5列布局 */
@media (max-width: 1919px) and (min-width: 1600px) {
  .masonry-container > .card {
    width: calc(20% - 15px);
    /* 一行5个 */
  }
}

/* 中等屏幕：4列布局 */
@media (max-width: 1599px) and (min-width: 1200px) {
  .masonry-container > .card {
    width: calc(25% - 9px);
    /* 一行4个 */
  }
}

/* 小屏幕：3列布局 */
@media (max-width: 1199px) and (min-width: 992px) {
  .masonry-container > .card {
    width: calc(33.333% - 8px);
    /* 一行3个 */
  }
}

/* 平板：2列布局 */
@media (max-width: 991px) and (min-width: 768px) {
  .masonry-container {
    padding: 8px;

    > .card {
      width: calc(50% - 6px);
      /* 一行2个 */
      margin-bottom: 8px;


      .card_content {
        padding: 8px;
      }
    }
  }
}

/* 移动端：2列布局 */
@media (max-width: 767px) and (min-width: 576px) {
  .masonry-container {
    padding: 6px;

    > .card {
      width: calc(50% - 4px);
      /* 一行2个 */
      margin-bottom: 6px;


      .card_content {
        padding: 10px;
      }
    }
  }
}

/* 超小屏幕：1列布局 */
@media (max-width: 575px) {
  .masonry-container {
    padding: 4px;

    > .card {
      width: 100%;
      /* 一行1个 */
      margin-bottom: 4px;


      .card_content {
        padding: 8px;

        .content-wrapper > span {
          font-size: 13px;
          margin: 3px 0;
        }
      }
    }
  }
}
</style>

<style scoped>
/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: "font_ms";
  font-weight: 400;
  src: url("//at.alicdn.com/wf/webfont/Z6Z6Ve9CViat/PZLjWH8qhBiv.woff2") format("woff2"),
  url("//at.alicdn.com/wf/webfont/Z6Z6Ve9CViat/gKkNeU0et3ML.woff") format("woff");
  font-variation-settings: normal;
  font-display: swap;
}
</style>

<style lang='scss' scoped>
// 全局样式优化
.popperClass {
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.popperClass::-webkit-scrollbar {
  width: 6px;
}

.popperClass::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.popperClass::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.popperClass::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.text {
  text-align: center;
  margin: 15% auto;
  font-size: 32px;
  font-weight: 300;
  background: linear-gradient(135deg, #FF8B87 0%, #FFD4E3 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  padding: 20px;
}

/* 响应式文本样式 */
@media (max-width: 768px) {
  .text {
    font-size: 24px;
    margin: 20% auto;
  }
}

@media (max-width: 480px) {
  .text {
    font-size: 20px;
    margin: 25% auto;
  }
}
</style>
